/**
 * Landing Page Interactivity
 */

// Constants
const VARIANT_ID = '51940113187118';
const SELLING_PLAN_ID = '691610059054';

// FAQ Toggle
function faq(el) {
  const a = el.nextElementSibling;
  const c = el.querySelector('.faq-chev');
  if (!a || !c) return;
  const open = a.classList.contains('open');
  document.querySelectorAll('.faq-a').forEach(x => x.classList.remove('open'));
  document.querySelectorAll('.faq-chev').forEach(x => x.classList.remove('open'));
  if (!open) { 
    a.classList.add('open'); 
    c.classList.add('open'); 
  }
}

// Video Testimonial Track
function initVidTrack() {
  const track = document.getElementById('vidTrack');
  if (!track) return;
  const cardW = 320 + 24;
  let cur = 0;
  
  function updateDots() {
    for (let i = 0; i < 3; i++) {
        const dot = document.getElementById('dot'+i);
        if(dot) dot.classList.toggle('active', i===cur);
    }
  }
  
  function scrollVid(dir) {
    cur = Math.max(0, Math.min(2, cur + dir));
    track.scrollTo({ left: cur * cardW, behavior: 'smooth' });
    updateDots();
  }

  track.addEventListener('scroll', () => { 
    cur = Math.round(track.scrollLeft / cardW); 
    updateDots(); 
  });

  // Drag to scroll
  let drag = false, sx, ss;
  track.addEventListener('mousedown', e => { 
    drag = true; sx = e.pageX; ss = track.scrollLeft; track.style.cursor = 'grabbing'; 
  });
  document.addEventListener('mousemove', e => { 
    if(drag) track.scrollLeft = ss - (e.pageX - sx); 
  });
  document.addEventListener('mouseup', () => { 
    drag = false; track.style.cursor = 'grab'; 
  });
  
  // Expose scrollVid to window if needed by buttons
  window.scrollVid = scrollVid;
}

// Lightbox Logic
(function() {
  const ov = document.getElementById('lbOverlay'),
        fr = document.getElementById('lbIframe'),
        cp = document.getElementById('lbCap'),
        cl = document.getElementById('lbClose'),
        lbInnerEl = document.getElementById('lbInner');

  if (!ov) return;

  function openLightbox(id, title, videoSrc) {
    cp.textContent = title || '';
    const existing = document.getElementById('lbVideo');
    if (existing) { existing.pause(); existing.remove(); }

    if (videoSrc) {
      fr.style.display = 'none';
      const vid = document.createElement('video');
      vid.id = 'lbVideo'; 
      vid.src = videoSrc; 
      vid.controls = true; 
      vid.muted = true; 
      vid.autoplay = true; 
      vid.playsinline = true;
      vid.style.cssText = 'width:100%;height:100%;display:block;border:none;background:#000;';
      lbInnerEl.insertBefore(vid, fr);
      const isWide = title && title.toLowerCase().includes('discount');
      lbInnerEl.style.maxWidth = isWide ? '800px' : '420px';
      lbInnerEl.style.aspectRatio = isWide ? '16/9' : '9/16';
    } else if (id) {
      fr.style.display = 'block';
      fr.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&mute=1&rel=0&modestbranding=1&playsinline=1';
      lbInnerEl.style.maxWidth = '720px'; 
      lbInnerEl.style.aspectRatio = '16/9';
    }
    ov.classList.add('lb-open'); 
    document.body.style.overflow = 'hidden';
    if(cl) cl.focus();
  }

  function closeLightbox() {
    ov.classList.remove('lb-open');
    fr.src = '';
    const vid = document.getElementById('lbVideo'); 
    if (vid) { vid.pause(); vid.remove(); }
    fr.style.display = 'block';
    document.body.style.overflow = '';
  }

  if(cl) cl.addEventListener('click', closeLightbox);
  ov.addEventListener('click', (e) => { if (e.target === ov) closeLightbox(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && ov.classList.contains('lb-open')) closeLightbox(); });

  // Bind to elements
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('.vidtest-thumb, .owner-video-thumb');
    if (thumb) {
        openLightbox(thumb.dataset.youtubeId, thumb.dataset.title, thumb.dataset.videoSrc);
    }
  });
})();

// AJAX Cart Handler
function addSubscriptionToCart(variantId, sellingPlanId, button) {
  if (button) {
    button.classList.add('loading');
    const spinner = button.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.remove('hidden');
  }
  
  const formData = {
    'items': [{ 'id': variantId, 'quantity': 1, 'selling_plan': sellingPlanId }],
    'sections': 'cart-drawer,cart-icon-bubble'
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(response => {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('theme:cart:open'));
    
    if (document.querySelector('cart-drawer')) {
      document.querySelector('cart-drawer').renderContents(response);
    } else if (window.upsell && window.upsell.openCart) {
      window.upsell.openCart();
    } else {
      window.location.href = window.Shopify.routes.root + 'cart';
    }
  })
  .catch((error) => {
    console.error('Error:', error);
    window.location.href = '/cart/' + variantId + ':1?selling_plan=' + sellingPlanId;
  })
  .finally(() => {
    if (button) {
        button.classList.remove('loading');
        const spinner = button.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.add('hidden');
    }
  });
}

// Animation on Scroll
function initAnimations() {
  const animationElements = document.querySelectorAll('.animatable');
  if (animationElements.length === 0) return;

  function scrollAnimation() {
    const windowHeight = window.innerHeight;
    const windowTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowBottom = windowTop + windowHeight;

    animationElements.forEach(el => {
      const rect = el.getBoundingClientRect();
      const elementTop = rect.top + windowTop;
      const elementBottom = elementTop + el.offsetHeight;
      if (elementBottom >= windowTop && elementTop <= windowBottom) {
        el.classList.add('animated');
      }
    });
  }
  window.addEventListener('scroll', scrollAnimation);
  window.addEventListener('resize', scrollAnimation);
  scrollAnimation();
}

// Lazy Load Heavy Videos
function initLazyVideos() {
  let activated = false;
  function activate() {
    if (activated) return;
    // Activate if scrolled a bit or if we are already seeing some videos
    if (window.scrollY > 200 || window.innerHeight > 800) {
      activated = true;
      document.querySelectorAll('.vidtest-card, .owner-video-thumb, .lazy-video-wrap').forEach(wrap => {
        const video = wrap.querySelector('video');
        if (!video) return;
        const source = video.querySelector('source');
        if (source && source.dataset.src) {
          source.src = source.dataset.src;
          video.load();
          video.style.display = 'block';
          const placeholder = wrap.querySelector('.owner-video-placeholder, .vidtest-video-placeholder');
          if (placeholder) placeholder.style.display = 'none';
          video.play().catch(() => {});
        }
      });
      window.removeEventListener('scroll', activate);
    }
  }
  window.addEventListener('scroll', activate);
  activate(); // check immediately
}

// Judge.me Scraper
function initJudgeMeScraper() {
  const target = document.getElementById('jm-custom-target');
  if (!target) return;

  const observer = new MutationObserver((mutations, obs) => {
    const source = document.querySelector('.jdgm-rev-widg');
    if (source && source.getAttribute('data-average-rating')) {
      renderScrapedUI(source);
      obs.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  function renderScrapedUI(source) {
    const rawRating = source.getAttribute('data-average-rating') || 0;
    const rating = parseFloat(rawRating);
    const count = source.getAttribute('data-number-of-reviews') || 0;

    let starsHtml = '';
    for (let i = 1; i <= 5; i++) {
      if (i <= Math.floor(rating)) {
        starsHtml += '<span class="jm-star-lg"><svg viewBox="0 0 24 24" fill="#ff946f"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path></svg></span>';
      } else if (i === Math.ceil(rating)) {
        const pct = (rating % 1 * 100).toFixed(0);
        starsHtml += '<span class="jm-star-lg"><svg viewBox="0 0 24 24"><defs><linearGradient id="glg47"><stop offset="' + pct + '%" stop-color="#ff946f"></stop><stop offset="' + pct + '%" stop-color="#e5e5e5"></stop></linearGradient></defs><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="url(#glg47)"></path></svg></span>';
      } else {
        starsHtml += '<span class="jm-star-lg"><svg viewBox="0 0 24 24" fill="#e5e5e5"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path></svg></span>';
      }
    }

    let barsHtml = '';
    const rows = source.querySelectorAll('.jdgm-histogram__row');
    rows.forEach(row => {
      const starLevel = row.getAttribute('data-rating');
      if (starLevel && starLevel !== 'null' && !isNaN(parseInt(starLevel))) {
        const barPct = row.getAttribute('data-percentage') || 0;
        barsHtml += '<div class="jm-bar-row"><span class="jm-bar-label">' + starLevel + ' ★</span><div class="jm-bar-track"><div class="custom-review-progress-fill" style="width:' + barPct + '%"></div></div><span class="jm-bar-pct">' + barPct + '%</span></div>';
      }
    });

    target.innerHTML = `
      <section class="off-white-section" style="padding-top: 0;">
        <div class="jm-widget-wrap">
          <div class="jm-summary">
            <div class="jm-big-score">${rating.toFixed(2)}</div>
            <div class="jm-stars-row">
              <div class="jm-stars-large">${starsHtml}</div>
              <div class="jm-count">${count} verified reviews &nbsp;·&nbsp; Powered by Judge.me</div>
            </div>
          </div>
          <div class="jm-divider"></div>
          <div class="jm-breakdown">${barsHtml}</div>
          <div class="jm-cta-wrap">
            <div class="jm-cta-text">Share your experience</div>
            <button class="jm-cta-btn" onclick="const link = document.querySelector('.jdgm-write-rev-link'); if(link) link.click()">Write a Review</button>
          </div>
        </div>
      </section>`;
  }
}

// Initialize everything
document.addEventListener('DOMContentLoaded', () => {
  initVidTrack();
  initAnimations();
  initLazyVideos();
  initJudgeMeScraper();
  
  // Bind CTA buttons
  document.querySelectorAll('a.btn-coral, a.sub-btn, a.hsc-cta').forEach(btn => {
    btn.addEventListener('click', (e) => {
        // Only if it doesn't have a specific different link
        const href = btn.getAttribute('href');
        if(!href || href === '#' || href === '') {
            e.preventDefault();
            addSubscriptionToCart(VARIANT_ID, SELLING_PLAN_ID, btn);
        }
    });
  });
});

// Expose functions globally for inline calls if any remain
window.faq = faq;
window.addSubscriptionToCart = addSubscriptionToCart;
